import { render, staticRenderFns } from "./BaseShowMore.vue?vue&type=template&id=b078a3a8&"
import script from "./BaseShowMore.vue?vue&type=script&lang=js&"
export * from "./BaseShowMore.vue?vue&type=script&lang=js&"
import style0 from "./BaseShowMore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports